import { DismissIcon, StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import styles from './styles.scss';

export interface Props {
  variant?: Variant;
  className?: string;
  onClick?(): void;
  href?: string;
}

export enum Variant {
  Dark = 'dark',
  Light = 'light',
  Float = 'float'
}

const CloseButton: React.FC<Props> = ({ onClick, variant = Variant.Dark, className, href }) => {
  const { modal } = useDispatch<Dispatch>();

  const handleClose = () => {
    if (onClick) {
      onClick();
    }
    modal.close();
  };

  return (
    <StarsButton
      variant="text"
      href={href}
      size={variant === Variant.Float ? 'small' : 'large'}
      className={classNames(styles.close, styles[variant as keyof typeof styles], className)}
      icon={<DismissIcon data-testid="dismiss-icon" />}
      onClick={href ? undefined : handleClose}
    />
  );
};

export default CloseButton;
